import smartDate from "@qrohlf/smart-date";
import cx from "classnames";
import { Badge } from "common/Badge";
import { SingleLineEditor } from "common/SingleLineEditor";
import { getReportCover } from "lib/getReportCover";
import { commonVerbs, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./ReportCard.scss";

export const ReportCard = ({ report, currentUser = {}, overlay }) => {
  const imgSrc = getReportCover(report);
  const backgroundImg = {
    backgroundImage: `url(${imgSrc})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };
  const A = ({ children, className }) => (
    <Link className={cx(styles.reportLink, className)} to={`/ride_reports/${report.slug}`}>
      {children}
    </Link>
  );
  return (
    <div className={styles.ReportCard}>
      <A className={styles.mediaContainer}>
        <div className={styles.media} style={backgroundImg} />
        {overlay && <img src={overlay} className={styles.weeklyBadge} />}
      </A>
      <div className={styles.cardContent}>
        <div className={styles.meta}>
          {report.publishStatus === "draft" && [
            <Badge key="draftBadge">
              <T id="ReportCard.draft" defaultMessage="draft" />
            </Badge>,
            " ∙ ",
          ]}
          <Link to={`/ride_reports/user/${report.user.id}`}>{report.user.name}</Link>
          {" ∙ "} {smartDate(report.createdAt)}
          {currentUser.id === report.user.id && [
            " ∙ ",
            <Link key="editButton" to={`/ride_reports/${report.slug}/edit`}>
              <Msg lowerCase m={commonVerbs.edit} />
            </Link>,
          ]}
        </div>
        <A>
          <h2 className={styles.title}>{report.title}</h2>
        </A>

        <h3 className={styles.subtitle}>
          {report.subtitle && (
            <SingleLineEditor defaultValue={report.subtitle} textAlignment="left" readOnly type="subtitle" />
          )}
        </h3>
      </div>
    </div>
  );
};
